import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Slide,
  Backdrop,
} from "@mui/material";
import Success_gif from "../../Assets/sucess_gif.gif"
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});



export default function SuccesModal({
  open,
  onClose,
  title = "Success!",
  subtitle = "Operation completed.",
  type = "success",
  autoClose = false,
  autoCloseTime = 3000,
  buttonText = "Close",
}) {
  // Auto-close effect
  useEffect(() => {
    if (open && autoClose) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseTime);
      return () => clearTimeout(timer);
    }
  }, [open, autoClose, autoCloseTime, onClose]);

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 300,
        sx: {
          backdropFilter: "blur(6px)",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: 4,
          px: 4,
          py: 3,
          textAlign: "center",
          maxWidth: 400,
          mx: "auto",
        },
      }}
    >
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <img
          src={Success_gif}
          className="h-[130px] w-[auto]"
          alt="Succces"
        ></img>
        <DialogTitle sx={{ fontWeight: 600, fontSize: "1.4rem" }}>
          {title}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        </DialogContent>
        {!autoClose && (
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              variant="contained"
              onClick={onClose}
              sx={{
                px: 4,
                textTransform: "uppercase",
                backgroundColor: "var(--primary-color)",
                "&:hover": {
                  backgroundColor: "var(--primary-hover)",
                },
              }}
            >
              {buttonText}
            </Button>
          </DialogActions>
        )}
      </Box>
    </Dialog>
  );
}
